(function () {
  const BENEFIT_PARAM = 'benefit';
  const TREATMENT_PARAM = 'treatment';
  const CARD_SEL = '.riva-treatment-product-card--grid';
  const TAG_SEL = '.riva-treatment-product-card__tag';
  const BENEFIT_PILL_SEL = '[data-benefit-filter]';
  const TREATMENT_PILL_SEL = '[data-treatment-filter]';
  const ACTIVE_CLS = 'riva-sidebar-tags__pill--active';
  const HIDDEN_CLS = 'riva-benefit-hidden';
  const COUNT_SEL = '.collection-filter__item--count';

  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function norm(value) {
    return (value || '').trim().toLowerCase();
  }

  function hideEmptyTags() {
    var cards = document.querySelectorAll(CARD_SEL);
    var availableBenefits = new Set();

    cards.forEach(function (card) {
      card.querySelectorAll(TAG_SEL).forEach(function (el) {
        availableBenefits.add(el.textContent.trim());
      });
    });

    document.querySelectorAll(BENEFIT_PILL_SEL).forEach(function (pill) {
      pill.hidden = !availableBenefits.has(pill.getAttribute('data-benefit-filter'));
    });

    document
      .querySelectorAll('.riva-sidebar-tags__pills')
      .forEach(function (group) {
        if (group.querySelector(TREATMENT_PILL_SEL)) return;
        var hasVisible = [].some.call(
          group.querySelectorAll('.riva-sidebar-tags__pill'),
          function (p) { return !p.hidden; }
        );
        var wrapper = group.closest('.collection-sidebar__group');
        if (wrapper) wrapper.hidden = !hasVisible;
      });
  }

  function applyFilters() {
    const benefit = getParam(BENEFIT_PARAM);
    const treatment = getParam(TREATMENT_PARAM);
    const cards = document.querySelectorAll(CARD_SEL);
    let visible = 0;

    cards.forEach((card) => {
      let matches = true;

      if (benefit) {
        const tags = [...card.querySelectorAll(TAG_SEL)].map((el) => norm(el.textContent));
        if (!tags.includes(norm(benefit))) matches = false;
      }

      if (matches && treatment) {
        if (norm(card.getAttribute('data-treatment-label')) !== norm(treatment)) matches = false;
      }

      card.classList.toggle(HIDDEN_CLS, !matches);
      if (matches) visible++;
    });

    document.querySelectorAll(BENEFIT_PILL_SEL).forEach((pill) => {
      pill.classList.toggle(ACTIVE_CLS, !!benefit && norm(pill.getAttribute('data-benefit-filter')) === norm(benefit));
    });
    document.querySelectorAll(TREATMENT_PILL_SEL).forEach((pill) => {
      pill.classList.toggle(ACTIVE_CLS, !!treatment && norm(pill.getAttribute('data-treatment-filter')) === norm(treatment));
    });

    const countEl = document.querySelector(COUNT_SEL);
    if (countEl && (benefit || treatment)) {
      countEl.textContent = visible + ' product' + (visible !== 1 ? 's' : '');
    }
  }

  function handleClick(e) {
    const benefitPill = e.target.closest(BENEFIT_PILL_SEL);
    const treatmentPill = e.target.closest(TREATMENT_PILL_SEL);
    const pill = benefitPill || treatmentPill;
    if (!pill) return;

    e.preventDefault();

    const param = benefitPill ? BENEFIT_PARAM : TREATMENT_PARAM;
    const attr = benefitPill ? 'data-benefit-filter' : 'data-treatment-filter';
    const value = pill.getAttribute(attr);
    const current = getParam(param);
    const next = current === value ? null : value;
    const url = new URL(window.location.href);

    if (next) {
      url.searchParams.set(param, next);
    } else {
      url.searchParams.delete(param);
    }

    history.pushState(null, '', url.toString());
    applyFilters();
  }

  function observeMobileFilters() {
    var holder = document.querySelector('#CollectionInlineFilterWrap');
    if (!holder || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      hideEmptyTags();
      applyFilters();
    }).observe(holder, { childList: true });
  }

  function init() {
    hideEmptyTags();
    document.addEventListener('click', handleClick);
    window.addEventListener('popstate', applyFilters);
    applyFilters();
    observeMobileFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
